import {
  useDialogListener as useDialogListenerBase,
  useDialogTrigger as useDialogTriggerBase,
  emitCustomEvent as emitCustomEventBase
} from '@satellite/composables/useEventBasedDialog';

export type JunoCustomEventMap = {
  'open-complete-checkout-dialog': CustomEvent<void>;
};

/**
 * Composable for listening to dialog events (used in dialog components)
 */
export function useDialogListener<K extends keyof JunoCustomEventMap>(dialogName: K) {
  return useDialogListenerBase<JunoCustomEventMap, K>(dialogName);
}

/**
 * Composable for triggering dialog events (used in components that open dialogs)
 */
export function useDialogTrigger<K extends keyof JunoCustomEventMap>(dialogName: K) {
  return useDialogTriggerBase<JunoCustomEventMap, K>(dialogName);
}

/**
 * Emit a custom event (overload without data)
 */
export function emitCustomEvent<K extends keyof JunoCustomEventMap>(
  eventName: K,
  target: EventTarget
): void;

/**
 * Emit a custom event (overload with data)
 */
export function emitCustomEvent<K extends keyof JunoCustomEventMap>(
  eventName: K,
  data: JunoCustomEventMap[K]['detail'],
  target?: EventTarget
): void;

/**
 * Emit a custom event
 */
export function emitCustomEvent<K extends keyof JunoCustomEventMap>(
  eventName: K,
  dataOrTarget?: JunoCustomEventMap[K]['detail'] | EventTarget,
  maybeTarget?: EventTarget
): void {
  emitCustomEventBase<JunoCustomEventMap, K>(eventName, dataOrTarget, maybeTarget);
}
